<template>
  <div class="col-xl-3 col-md-4 col-sm-6">
    <div :class="getPortletClass()" :style="setPortletCollors()">
      <router-link :to="'/construction/' + construction.id">
        <div class="portlet-body">
          <div class="tile-name project-list-client">
            <div
              class="project-portlet-parentname"
              v-if="construction.parent_name !== null"
            >
              {{ construction.parent_name }}
            </div>
            <div class="project-portlet-name">{{ construction.name }}</div>
            <small v-if="construction.pur">
              {{ construction.pur }}
            </small>
            <span
              v-if="
                !isSubcontractor &&
                  construction.customer &&
                  construction.customer.companyname
              "
            >
              {{ construction.customer.companyname }}
            </span>
          </div>
          <label class="project-portlet-badge" :class="classBadge()">{{
            statusName(construction.status)
          }}</label>
          <div>
            <div class="project-portlet-row" v-if="construction.company">
              <p class="project-portlet-label">Firma:</p>
              <span class="project-portlet-value"
                >{{ construction.company.name }}</span
              >
            </div>
            <div class="project-portlet-row">
              <p class="project-portlet-label">Kierownik:</p>
              <span class="project-portlet-value"
                >{{ construction.manager.firstname }}
                {{ construction.manager.lastname }}</span
              >
            </div>
            <div class="project-portlet-row">
              <p class="project-portlet-label">Planowano od:</p>
              <span
                class="project-portlet-value project-portlet-date"
                v-if="construction.planned_start_date"
                >{{
                  construction.planned_start_date | date
                }}</span
              >
            </div>
            <div class="project-portlet-row" v-if="!isSubcontractor">
              <p class="project-portlet-label">Wysłano fakture:</p>
              <span
                class="project-portlet-value project-portlet-date"
                v-if="construction.planned_end_date"
                >{{
                  construction.planned_end_date | date
                }}</span
              >
              <span v-else>-</span>
            </div>
          </div>
          <div
            class="row project-importantdates"
            v-if="
              construction.important_events &&
                construction.important_events.length > 0
            "
          >
            <strong class="col-12 project-importantdatetitle text-danger"
              >Deadline</strong
            >
            <ul class="col-12">
              <li
                v-for="(event, index) in construction.important_events"
                :key="index"
                class="project-importantdate"
              >
                <p>{{ event.label }}</p>
                <span>{{ event.date }}</span>
              </li>
            </ul>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { lightenDarkenColor } from "@/services/helpers";
import {formatDateOnly} from "@/services/helpers";

export default {
  name: "ConstructionPortlet",
  props: {
    construction: Object,
  },
  data() {
    return {
      darkenPercent: -40,
    };
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  computed: {
    isSubcontractor() {
      return this.getRole === "subcontractor";
    },
    ...mapGetters("user", ["getRole", "hasAccess"]),
    ...mapGetters("app", ["statusName"]),
  },
  created() {},
  methods: {
    classBadge: function() {
      let status = this.construction.status;
      return {
        badge: true,
        "w-100": true,
        "badge-success": status === "finished",
        "badge-primary": status === "in_progress",
        "badge-warning ": status === "not_started",
        "badge-danger ": status === "not_payment",
        "badge-info ": status === "other",
      };
    },
    // lightenDarkenColor,
    setPortletCollors: function() {
      if (this.construction.color) {
        return (
          "--project-color:" +
          this.construction.color +
          "; --project-color-darken:" +
          lightenDarkenColor(
            "#" + this.construction.color.substring(1),
            this.darkenPercent
          )
        );
      }
      return false;
    },
    getPortletClass: function() {
      let classcss = {
        portlet: true,
        "project-portlet": true,
        tile: true,
      };
      if (
        this.construction.parent_id === null &&
        this.construction.color === null
      ) {
        return classcss;
      }
      if (
        this.construction.parent_id !== null &&
        this.construction.color !== null
      ) {
        classcss["project-portlet--subproject"] = true;
      }
      if (
        this.construction.parent_id === null &&
        this.construction.color !== null
      ) {
        classcss["project-portlet--mainproject"] = true;
      }
      return classcss;
    },
  },
};
</script>
